import React, { useRef, useState,useEffect} from "react";
import EventInfo from "./EventInfo";
import LayoutPanel from "./LayoutPanel";
import BookingQuestions from "./BookingQuestions";
import SettingsPanel from "./SettingsPanel";
import axios from "axios";
import Swal from "sweetalert2";
import API_BASE_URL from "../config";
export const showToast = (title, icon = "success") => {
  Swal.fire({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    icon,
    title,
  });
};

const AdvancedMenu = ({ eventId,eventTitle }) => {
  const [activePanel, setActivePanel] = useState("eventInfo"); // To track which panel is active
  const eventInfoRef = useRef();
  const layoutRef = useRef();
  const bookingQuestionsRef = useRef();
  const settingsRef = useRef();
  const [eventName, setEventName] = useState(eventTitle || "");
  const handlePanelToggle = (panel) => {
    setActivePanel(activePanel === panel ? "" : panel); // Toggle the active panel
  };
  // Optional: sync with parent if needed
  useEffect(() => {
    setEventName(eventTitle || "");
  }, [eventTitle]);

  const handleSave = async () => {
    const eventInfo = eventInfoRef.current.getState();
    const layout = layoutRef.current.getState();
    const bookingQuestions = bookingQuestionsRef.current.getState();
    const settings = settingsRef.current.getState();
    try {
      // Save Event Info
      await axios.put(
        `${API_BASE_URL}/events/${eventId}/advanced/info`,
        eventInfo
      );

      // Save Layout
      await axios.put(
        `${API_BASE_URL}/events/${eventId}/advanced/layout`,
        layout
      );

      // Save Booking Questions
      await axios.put(
        `${API_BASE_URL}/events/${eventId}/advanced/questions`,
        bookingQuestions
      );

      // Save Settings
      await axios.put(
        `${API_BASE_URL}/events/${eventId}/advanced/settings`,
        settings
      );

      showToast("Event settings saved successfully!");
    } catch (error) {
      console.error(error);
      showToast("Failed to save one or more event settings.");
    }
  };

  return (
    <div className="p-0">
      <div className="accordion" id="advancedAccordion">
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={`accordion-button ${
                activePanel === "eventInfo" ? "" : "collapsed"
              }`}
              type="button"
              onClick={() => handlePanelToggle("eventInfo")}
            >
              Event Info
            </button>
          </h2>
          <div
            id="collapseEventInfo"
            className={`accordion-collapse collapse ${
              activePanel === "eventInfo" ? "show" : ""
            }`}
          >
            <div className="accordion-body">
              <EventInfo ref={eventInfoRef} eventId={eventId} eventTitle={eventName}/>
            </div>
          </div>
        </div>

        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={`accordion-button ${
                activePanel === "layout" ? "" : "collapsed"
              }`}
              type="button"
              onClick={() => handlePanelToggle("layout")}
            >
              Layout
            </button>
          </h2>
          <div
            id="collapseLayout"
            className={`accordion-collapse collapse ${
              activePanel === "layout" ? "show" : ""
            }`}
          >
            <div className="accordion-body">
              <LayoutPanel ref={layoutRef} eventId={eventId} />
            </div>
          </div>
        </div>

        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={`accordion-button ${
                activePanel === "bookingQuestions" ? "" : "collapsed"
              }`}
              type="button"
              onClick={() => handlePanelToggle("bookingQuestions")}
            >
              Booking Questions
            </button>
          </h2>
          <div
            id="collapseBookingQuestions"
            className={`accordion-collapse collapse ${
              activePanel === "bookingQuestions" ? "show" : ""
            }`}
          >
            <div className="accordion-body">
              <BookingQuestions ref={bookingQuestionsRef} eventId={eventId} />
            </div>
          </div>
        </div>

        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={`accordion-button ${
                activePanel === "settings" ? "" : "collapsed"
              }`}
              type="button"
              onClick={() => handlePanelToggle("settings")}
            >
              Settings
            </button>
          </h2>
          <div
            id="collapseSettings"
            className={`accordion-collapse collapse ${
              activePanel === "settings" ? "show" : ""
            }`}
          >
            <div className="accordion-body">
              <SettingsPanel ref={settingsRef} eventId={eventId} />
            </div>
          </div>
        </div>
      </div>

      <div className="text-end mt-4">
        <button className="btn btn-success mb-4" onClick={handleSave}>
          <i class="bi bi-floppy-fill"></i>&nbsp; Save
        </button>
      </div>
    </div>
  );
};

export default AdvancedMenu;
